import React, { useMemo, useEffect } from 'react';
import { TabPane } from 'reactstrap';
import { TABS } from '../..';
import { AutoSizer, List } from 'react-virtualized';
import { verifyRoles } from 'components/Authentication/VerifyRoles';
import { CheckboxChat } from '../../styled';
import QueueTag from '../QueueTag';

export const TabChatsInAttendance = ({
  chats = [],
  queues,
  idNameTags,
  handleCheck,
  answerConversation,
  selectedConversations,
  currentOpenChatId
}) => {
  const totalUnreadMessages = useMemo(() => {
    if (!chats) return 0;

    if (typeof chats === 'object' && !Array.isArray(chats)) {
      return Object.values(chats).reduce((total, conversation) => {
        return total + (conversation?.novas_mensagens || 0);
      }, 0);
    }
    // Caso padrão (array)
    return (chats || []).reduce((total, conversation) => {
      return total + (conversation?.novas_mensagens || 0);
    }, 0);
  }, [chats]);

  useEffect(() => {
    const originalTitle = document.title.replace(/^\(\d+\)\s/, '');

    if (totalUnreadMessages > 0) {
      document.title = `(${totalUnreadMessages}) ${originalTitle}`;
    } else {
      document.title = originalTitle;
    }

    return () => {
      document.title = originalTitle;
    };
  }, [totalUnreadMessages]);
  return (
    <TabPane
      tabId={TABS.IN_ATTENDANCE}
      style={{
        width: '100%',
        height: '94%'
      }}
    >
      <AutoSizer>
        {({ width, height }) => (
          <List
            style={{
              scrollbarWidth: 'thin',
              margin: '0px',
              padding: '0px'
            }}
            width={width}
            height={height}
            rowHeight={140}
            rowCount={chats?.length || 0}
            rowGetter={({ index }) => chats[index] || {}}
            rowRenderer={({ key, index, style }) => {
              const id = chats[index]?.id || chats[index]?._id;
              return (
                <div key={key} style={style}>
                  {verifyRoles(['CHAT_MULTIPLE_TRANSFER']) && (
                    <CheckboxChat
                      checked={selectedConversations.includes(id)}
                      onClick={(event) => {
                        handleCheck(event, id);
                      }}
                      type="checkbox"
                    />
                  )}

                  <QueueTag
                    checked={selectedConversations.includes(id)}
                    isSelected={id === currentOpenChatId}
                    key={key}
                    style={style}
                    conversation={chats[index]}
                    idNameTags={idNameTags}
                    allQueues={queues}
                    functionAnswerConversation={answerConversation}
                  />
                </div>
              );
            }}
          />
        )}
      </AutoSizer>
    </TabPane>
  );
};
